import {Helmet} from 'react-helmet';
import {
  ExpertDetails,
  ServiceDetails,
  WorkSamplesContainer,
  RelatedServicesContainer,
  ExpertUnavailable,
} from 'sections/services-marketplace/experts/sections/profile/components';
import {
  AppLayout,
  RequestQuote,
} from 'sections/services-marketplace/experts/components';
import React from 'react';
import {GetProfileQueryData} from 'sections/services-marketplace/experts/sections/profile/graphql/GetProfileQuery.graphql';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import i18nArgs from '../locales';
import {Profile as ProfileUtils} from 'sections/services-marketplace/experts/utilities';
import ReviewsContainer from 'sections/services-marketplace/experts/sections/profile/profile-listing/ReviewsContainer';
import {Routes} from 'sections/services-marketplace/experts/utilities/routes';
import {Redirect} from 'react-router-dom';

interface OwnProps {
  profile: GetProfileQueryData.Profile;
}

type CombinedProps = OwnProps & WithI18nProps;

export function Profile({profile, i18n}: CombinedProps) {
  const {
    handle,
    businessName,
    bio,
    serviceListing = null,
    image,
    address,
    languages,
    acceptingLeads,
  } = profile;

  if (serviceListing === null)
    return <Redirect to={Routes.profilePath(handle)} />;

  const canonicalPath = `https://experts.shopify.com${Routes.profileServiceListingPath(
    handle,
    serviceListing.handle
  )}`;

  return (
    <>
      <Helmet>
        <title>
          {i18n.translate('Profile.Meta.profileServiceListingTitle', {
            businessName,
          })}
        </title>
        <meta
          name="description"
          content={i18n.translate(
            'Profile.Meta.profileServiceListingDescription',
            {
              businessName,
              serviceLabel: serviceListing.shortLabel.toLowerCase(),
            }
          )}
        />
        <link rel="canonical" href={canonicalPath} />
      </Helmet>
      <AppLayout>
        <AppLayout.Container slim>
          <AppLayout.Section size="TwoThirds">
            {!acceptingLeads && <ExpertUnavailable />}
            <ExpertDetails
              bio={bio}
              expertHandle={handle}
              currentOrganization={{
                businessName,
                address,
              }}
              languages={languages}
              languageList={ProfileUtils.getLanguageMap()}
              profileImage={image}
            />
            <ServiceDetails
              serviceListing={serviceListing}
              metrics={serviceListing.serviceMetrics}
            />
            <WorkSamplesContainer workSamples={serviceListing.workSamples} />

            <ReviewsContainer />
          </AppLayout.Section>
          <AppLayout.Section size="OneThird">
            <RequestQuote
              startingPrice={serviceListing.startingPrice}
              serviceHandle={serviceListing.handle}
              acceptingLeads={acceptingLeads}
              expertHandle={handle}
              businessName={businessName}
            />
          </AppLayout.Section>
        </AppLayout.Container>
      </AppLayout>
      <RelatedServicesContainer
        expertHandle={handle}
        serviceHandle={serviceListing.handle}
        profileHandle={handle}
      />
    </>
  );
}

export default withI18n(i18nArgs)(Profile);
